import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import {Checktoken} from "../../models/checktoken.model";
import {environment} from "../../../environments/environment";
import {AuditLogsService} from "../../services/auditlogs.service";

@Component({
  selector: 'app-token-verification',
  standalone: true,
  template: `
    <div>Please wait...</div>`
})
export class TokenVerificationComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private auditLogsService : AuditLogsService
  ) {}

  ngOnInit(): void {

    const token = this.route.snapshot.queryParamMap.get('token');
    const orgId = this.route.snapshot.queryParamMap.get('enterprise_org_id');

    if (token && orgId) {
      this.authService.verifyToken(token, orgId).subscribe({
        next: (response: Checktoken) => {
          if (response.message === 'Valid token') {
            localStorage.setItem(`token`, token);
            localStorage.setItem(`orgId`, orgId);
            localStorage.setItem(`email`, response.user_email);
            localStorage.setItem(`user_full_name`, response.user_full_name);
            localStorage.setItem(`token_expires_at`, new Date(response.token_expires_at).toISOString());

            this.auditLogsService.postLog("Successful Login").subscribe({
              next: (response: Checktoken) => {

              },error: (error) => {

              }
            });

            this.router.navigate(['/rider-trips'], {
              queryParams: { enterprise_org_id: orgId }
            });
          } else {
            this.authService.logout()
          }
        },
        error: (err) => {
          console.error("Token verification failed : ",err);
          this.authService.logout()
        }
      });
    } else {
      if (this.authService.isLoggedIn()) {
        this.router.navigate(['/rider-trips'], {
          queryParams: { enterprise_org_id: localStorage.getItem('orgId') }
        });
      }else {
        this.authService.logout();
      }
    }
  }
}
